import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
import SearchPaging from "./../factories/search-paging";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
function TicketPriorityViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.Priority())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
}
Bao.inherit(TicketPriorityViewModel, SearchPaging);
TicketPriorityViewModel.prototype.PrimaryKey = "TicketPriorityId";
TicketPriorityViewModel.prototype.RefreshUrl = "TicketPriority/GetTicketPriority";
TicketPriorityViewModel.prototype.SaveUrl = "TicketPriority/SaveTicketPriority";
TicketPriorityViewModel.prototype.DeleteUrl = "TicketPriority/DeleteTicketPriority";
TicketPriorityViewModel.prototype.IsInUseUrl = "TicketPriority/IsTicketPriorityInUse";
TicketPriorityViewModel.prototype.PermissionForward = "TicketPriorityMoveForwardSearch";
TicketPriorityViewModel.prototype.PermissionBackward = "TicketPriorityMoveBackwardSearch";
TicketPriorityViewModel.prototype.PermissionSave = "TicketPrioritySave";
TicketPriorityViewModel.prototype.PermissionRefresh = "TicketPriorityRefresh";
TicketPriorityViewModel.prototype.PermissionDelete = "TicketPriorityDelete";
export default TicketPriorityViewModel;